import React, { useEffect, useState } from "react";
import Header from "../component/Header";
import Sidebar from "../component/Sidebar";
import { AesDecrypt } from "../middleware/AesDecrypt";
import { AesEncrypt } from "../middleware/AesEncrypt";
import axios from "axios";
import { Base_url, Base_url_bbbs, Base_url_api_live } from "../config";
import { useNavigate } from "react-router-dom";

import ReactDOM from "react-dom";
import ReactPaginate from "react-paginate";
import bigInt from "big-integer";
import Select from "react-select";

const initialData = {
  pro: "Sameday",
  proTwo: "visa",
  proThree: "",
  profive: "",
  proFour: "1",
};

let initialDataa =  {
    "name": "visa",
    "active": true,
    "charge": 0,
    "pg": 2,
    "img": "image/home/asdfvisa.png",
    "pro": ["Sameday", "T2", "T3", "T1", "T4"],
    "promsg": "this is pro message 7" 
  }

  
let initialDataae =  {
    "name": "visa",
    "active": true,
    "charge": 0,
    "pg": 2,
    "img": "image/home/asdfvisa.png",
    "pro": ["Sameday", "T2", "T3", "T1", "T4"],
    "promsg": "this is pro message 7" 
  }

const initialDataedu = {
  pro: "Sameday",
  proTwo: "visa",
  proThree: "",
  profive: "",
  proFour: "1",
};

const priorityOptions = [
  { value: "Sameday", label: "Sameday" },
  { value: "T1", label: "T1" },
  { value: "T2", label: "T2" },
  { value: "T3", label: "T3" },
  { value: "T4", label: "T4" },
];


let ReneditGateway = () => {
  let [data, setData] = useState();

  let [one, setOne] = useState();
  let [two, setTwo] = useState();
  let [three, setThree] = useState(true);

  let [five, setFive] = useState();
  let [six, setSix] = useState();
  let [seven, setSeven] = useState(true);

  let [eight, setEight] = useState();
  let [nine, setNine] = useState();
  let [ten, setTen] = useState(true);


  let [four, setFour] = useState();

  let [utilityflow, setUtilityflow] = useState(true);

  let [loading, setLoading] = useState(false);

  let navigate = useNavigate();
  let [value, inputvalue] = useState();
  let [text, setText] = useState("");

  let [eduval, setEduval] = useState()
  let [utival, setUti] = useState()
  let [finedata, setFinedata] = useState()

  const [formBlocks, setFormBlocks] = useState([initialData]);
  
  const [formBlocksa, setFormBlocksa] = useState([initialDataa]);

    const handleChangea = (index, key, value) => {
    const updated = [...formBlocksa];
    updated[index][key] = value;
    setFormBlocksa(updated);
  };

  const addNewBlocka = () => {
    setFormBlocksa([...formBlocksa, { ...initialDataa }]);
  };

  const removeBlocka = (index) => {
    const updated = [...formBlocksa];
    updated.splice(index, 1);
    setFormBlocksa(updated);
  };

  
  let fine_imgs = [
    { name : "visa" , value : "image/home/asdfvisa.png"},
    { name : "master" , value : "image/home/asdfmaster.png"},
    { name : "RuPay" , value : "image/home/asdfrupay.png"},
    { name : "AMEX" , value : "image/home/amedd.png"},
    { name : "Dynex" , value : "image/home/ccapplybotseven.png"},
    { name : "Prepaid" , value : "image/home/Frame 1948755795.png.ivzi8d9llc4j1sgatj8vw.png"}
  ]


   const saveJSONa = async () => { 
   

    let updatedData = formBlocksa.map(item => {
      let found = fine_imgs.find(img => img.name === item.name);
      if (found) {
        return { ...item, img: found.value , charge: Number(item.charge)    }; // replace img with matching value
      }
      return item; // if not found, keep original
    });

    console.log( updatedData , 'formBlocksa');

     let apicall = await axios({
      method: "post",
      url: Base_url_api_live + "admin2/flowwisenew_fine",
      data: {
        data: updatedData
      }
    })
      .then((dat) => {

        // setFinedata(dat.data.data)

        console.log(dat.data, "Jsson dddddddddddddddddddddddddddddddddddddddddd");

        alert('Update Success')
        newwwfine()
      })
      .catch((ee) => {
        console.log(ee, "Jsson dddddddddddddddddddddddddddddddddddddddddd");
      });



  };

   const saveJSONae = async () => { 

    console.log( formBlocksae , 'formBlocksa');
 
   

    let updatedData = formBlocksae.map(item => {
      let found = fine_imgs.find(img => img.name === item.name);
      if (found) {
        return { ...item, img: found.value , charge: Number(item.charge)    }; // replace img with matching value
      }
      return item; // if not found, keep original
    });

    

     let apicall = await axios({
      method: "post",
      url: Base_url_api_live + "admin2/flowwisenew_fine_edu",
      data: {
        data: updatedData
      }
    })
      .then((dat) => {

        // setFinedata(dat.data.data)

        console.log(dat.data, "Jsson dddddddddddddddddddddddddddddddddddddddddd");

        alert('Update Success')
        newwwfineedu()
      })
      .catch((ee) => {
        console.log(ee, "Jsson dddddddddddddddddddddddddddddddddddddddddd");
      });



  };






  const [formBlocksae, setFormBlocksae] = useState([initialDataae]);

    const handleChangeae = (index, key, value) => {
    const updated = [...formBlocksae];
    updated[index][key] = value;
    setFormBlocksae(updated);
  };

  const addNewBlockae = () => {
    setFormBlocksae([...formBlocksae, { ...initialDataae }]);
  };

  const removeBlockae = (index) => {
    const updated = [...formBlocksae];
    updated.splice(index, 1);
    setFormBlocksae(updated);
  };


 



  const handleChange = (index, key, value) => {
    const updated = [...formBlocks];
    updated[index][key] = value;
    setFormBlocks(updated);
  };

  const addNewBlock = () => {
    setFormBlocks([...formBlocks, { ...initialData }]);
  };

  const removeBlock = (index) => {
    const updated = [...formBlocks];
    updated.splice(index, 1);
    setFormBlocks(updated);
  };
 
  const [formBlocksedu, setFormBlocksedu] = useState([initialDataedu]);

  const handleChangeedu = (index, key, value) => {
    const updated = [...formBlocksedu];
    updated[index][key] = value;
    setFormBlocksedu(updated);
  };

  const addNewBlockedu = () => {
    setFormBlocksedu([...formBlocksedu, { ...initialDataedu }]);
  };

  const removeBlockedu = (index) => {
    const updated = [...formBlocksedu];
    updated.splice(index, 1);
    setFormBlocksedu(updated);
  };


  const saveJSON = async () => { 
    console.log(formBlocks, 'formBlocks');

    let apicall = await axios({
      method: "post",
      url: Base_url_api_live + "admin2/flowwisenew",
      data: {
        data: formBlocks
      }
    })
      .then((dat) => {

        // setFinedata(dat.data.data)

        console.log(dat.data, "Jsson dddddddddddddddddddddddddddddddddddddddddd");

        alert('Update Success')
        newww()
      })
      .catch((ee) => {
        console.log(ee, "Jsson dddddddddddddddddddddddddddddddddddddddddd");
      });
  };


  const saveJSONedu = async () => {
    console.log(formBlocksedu, 'formBlocks');
 

    let apicall = await axios({
      method: "post",
      url: Base_url_api_live + "admin2/flowwisenewedu",
      data: {
        data: formBlocksedu
      }
    })
      .then((dat) => {

        // setFinedata(dat.data.data)

        console.log(dat.data, "Jsson dddddddddddddddddddddddddddddddddddddddddd");

        alert('Update Success')
        newww()
      })
      .catch((ee) => {
        console.log(ee, "Jsson dddddddddddddddddddddddddddddddddddddddddd");
      });
  };

  useEffect(() => {
    Start();
    newww()
    newwwedu()
    newwwfine()
    newwwfineedu()
  }, []);

  let newwwedu = async () => {

    let apicall = await axios({
      method: "get",
      url: Base_url_api_live + "gst/changeedugetedu", 
    })
      .then((dat) => {
 
        setFormBlocksedu(dat.data.flowise || [])
        console.log(dat.data.data, "Jsson dddddddddddddddddddddddddddddddddddddddddd");


      })
      .catch((ee) => {
        console.log(ee, 'eeeeeeeeeeee')
      });



  }

  let newwwfine = async () => {

    let apicall = await axios({
      method: "get",
      url: Base_url_api_live + "gst/changeedugetedu_fine", 
    })
      .then((dat) => {
 
        setFormBlocksa(dat.data.data || [])
        console.log(dat.data.data, "Jsson dddddddddddddddddddddddddddddddddddddddddd");


      })
      .catch((ee) => {
        console.log(ee, 'eeeeeeeeeeee')
      });



  }

  let newwwfineedu = async () => {

    let apicall = await axios({
      method: "get",
      url: Base_url_api_live + "gst/changeedugetedu_fineedu", 
    })
      .then((dat) => {
 
        setFormBlocksae(dat.data.data || [])
        console.log(dat.data.data, "Jsson dddddddddddddddddddddddddddddddddddddddddd");


      })
      .catch((ee) => {
        console.log(ee, 'eeeeeeeeeeee')
      });



  }




  let newww = async () => {

    let apicall = await axios({
      method: "get",
      url: Base_url_api_live + "gst/changeeduget",
    })
      .then((dat) => {

        setFinedata(dat.data.data)
        setFormBlocks(dat.data.flowise)
        console.log(dat.data.data, "Jsson dddddddddddddddddddddddddddddddddddddddddd");


      })
      .catch((ee) => {
        console.log(ee, 'eeeeeeeeeeee')
      });



  }


  let Start = async () => {
    let token = await localStorage.getItem("token");
    if (token === undefined || token === null || token === "") {
      navigate("/login");
    }
  };

  let chsngeuttty = async (val, cmd) => {
    // console.log(val, "ggggggggggggg");
    // setUtilityflow(val);

    let token = await localStorage.getItem("token");

    let pp = { token, page: 1, limit: 10, utility: val };
    let data = await AesEncrypt(pp);

    let apicall = await axios({
      method: "post",
      url: Base_url + "/admin2/flowwise",
      data: pp,
    })
      .then((dat) => {
        console.log(
          dat.data.data,
          "Jsson dddddddddddddddddddddddddddddddddddddddddd "
        );

        if (dat.data.status === true) {
        } else {
        }
      })
      .catch((ee) => { });
  };

  let chsngeutttys = async (val, cmd, gateway) => {
    // console.log(val, "ggggggggggggg");
    // setUtilityflow(val);

    let token = await localStorage.getItem("token");

    let pp = { token, page: 1, limit: 10, utility: val, cmd, gateway };
    let data = await AesEncrypt(pp);

    let apicall = await axios({
      method: "post",
      url: Base_url + "/admin2/flowwise",
      data: pp,
    })
      .then((dat) => {
        console.log(
          dat.data.data,
          "Jsson dddddddddddddddddddddddddddddddddddddddddd "
        );

        if (dat.data.status === true) {
        } else {
        }
      })
      .catch((ee) => { });
  };



  let Submitt = async (edy) => {
    console.log(eduval, 'eduvaleduval')


    if (edy === 'edu') {
      let token = await localStorage.getItem("token");

      let pp = { token, val: edy, num: Number(eduval) };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url_api_live + "gst/changeedu",
        data: pp,
      })
        .then((dat) => {
          console.log(
            dat.data.data,
            "Jsson dddddddddddddddddddddddddddddddddddddddddd "
          );
          newww()
          if (dat.data.status === true) {
          } else {
          }
        })
        .catch((ee) => { });
    } else {
      let token = await localStorage.getItem("token");

      let pp = { token, val: 'uti', num: Number(utival) };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url_api_live + "gst/changeedu",
        data: pp,
      })
        .then((dat) => {
          console.log(
            dat.data.data,
            "Jsson dddddddddddddddddddddddddddddddddddddddddd "
          );
          newww()
          if (dat.data.status === true) {
          } else {
          }
        })
        .catch((ee) => { });
    }





  }


  return (
    <div>
      <div className="row">
        <Header />
        <div
          className="col-10"
          style={{
            overflowY: "scroll",
            height: "100vh",
            scrollbarWidth: "none",
          }}
        >
          <p className="mt-5">New Flowwise Utility</p>


          <div style={{ padding: 20 }}>
            {formBlocks?.map((block, index) => (
              <div key={index} className="row" style={{ marginBottom: 10 }}>
                <div className="col-2">
                  <select
                    onChange={(e) =>
                      handleChange(index, "pro", e.target.value)
                    }
                    value={block.pro}
                    style={{ width: "98%" }}
                  >
                    <option value="Sameday">Sameday</option>
                    <option value="T1">T1</option>
                    <option value="T2">T2</option>
                    <option value="T3">T3</option>
                    <option value="T4">T4</option>
                    <option value="Low">Low</option>
                  </select>
                </div>

                <div className="col-2">
                  <select
                    onChange={(e) =>
                      handleChange(index, "proTwo", e.target.value)
                    }
                    value={block.proTwo}
                    style={{ width: "98%" }}
                  >
                    <option value="visa">Visa</option>
                    <option value="master">Mastercard</option>
                    <option value="RuPay">Rupay</option>
                    <option value="AMEX">Amex</option>
                    <option value="Dynex">Diner</option>
                    <option value="Prepaid">Prepaid</option>
                  </select>
                </div>

                <div className="col-5">
                  <div className="row" >
                    <div className="col-6">
                      <input
                        type="text"
                        onChange={(e) =>
                          handleChange(index, "proThree", e.target.value)
                        }
                        value={block.proThree}
                        placeholder="min"
                        style={{ width: "98%" }}
                      />
                    </div>
                    <div className="col-6">
                      <input
                        type="text"
                        onChange={(e) =>
                          handleChange(index, "profive", e.target.value)
                        }
                        value={block.profive}
                        placeholder="max"
                        style={{ width: "98%" }}
                      />

                    </div>
                  </div>



                </div>

                <div className="col-2">
                  <select
                    onChange={(e) =>
                      handleChange(index, "proFour", e.target.value)
                    }
                    value={block.proFour}
                    style={{ width: "98%" }}
                  >
                    <option value="1">Phonepe</option>
                    <option value="2">Payu Alpha (old)</option>
                    <option value="3">Payu Beta (new)</option>
                    <option value="8">Billdesk</option>
                    <option value="9">Billdesk Edu</option>
                  </select>
                </div>

                <div className="col-1">
                  <button onClick={() => removeBlock(index)}>❌</button>
                </div>
              </div>
            ))}

            <div style={{ marginTop: 20 }}>
              <button onClick={addNewBlock} style={{ marginRight: 10 }}>
                ➕ Add New
              </button>
              <button onClick={saveJSON}>💾 Save</button>
            </div>
          </div>

          <p className="mt-5">New Flowwise Edu</p>


          <div style={{ padding: 20 }}>
            {formBlocksedu.map((block, index) => (
              <div key={index} className="row" style={{ marginBottom: 10 }}>
                <div className="col-2">
                  <select
                    onChange={(e) =>
                      handleChangeedu(index, "pro", e.target.value)
                    }
                    value={block.pro}
                    style={{ width: "98%" }}
                  >
                    <option value="Sameday">Sameday</option>
                    <option value="T1">T1</option>
                    <option value="T2">T2</option>
                    <option value="T3">T3</option>
                    <option value="T4">T4</option>
                    <option value="Low">Low</option>
                  </select>
                </div>

                <div className="col-2">
                  <select
                    onChange={(e) =>
                      handleChangeedu(index, "proTwo", e.target.value)
                    }
                    value={block.proTwo}
                    style={{ width: "98%" }}
                  >
                    <option value="visa">Visa</option>
                    <option value="master">Mastercard</option>
                    <option value="RuPay">Rupay</option>
                    <option value="AMEX">Amex</option>
                    <option value="Dynex">Diner</option>
                    <option value="Prepaid">Prepaid</option>
                  </select>
                </div>

                <div className="col-5">
                  <div className="row" >
                    <div className="col-6">
                      <input
                        type="text"
                        onChange={(e) =>
                          handleChangeedu(index, "proThree", e.target.value)
                        }
                        value={block.proThree}
                        placeholder="min"
                        style={{ width: "98%" }}
                      />
                    </div>
                    <div className="col-6">
                      <input
                        type="text"
                        onChange={(e) =>
                          handleChangeedu(index, "profive", e.target.value)
                        }
                        value={block.profive}
                        placeholder="max"
                        style={{ width: "98%" }}
                      />

                    </div>
                  </div>



                </div>

                <div className="col-2">
                  <select
                    onChange={(e) =>
                      handleChangeedu(index, "proFour", e.target.value)
                    }
                    value={block.proFour}
                    style={{ width: "98%" }}
                  >
                    <option value="1">Phonepe</option>
                    <option value="2">Payu Alpha (old)</option>
                    <option value="3">Payu Beta (new)</option>
                    <option value="8">Billdesk</option>
                    <option value="9">Billdesk Edu</option>
                  </select>
                </div>

                <div className="col-1">
                  <button onClick={() => removeBlockedu(index)}>❌</button>
                </div>
              </div>
            ))}

            <div style={{ marginTop: 20 }}>
              <button onClick={addNewBlockedu} style={{ marginRight: 10 }}>
                ➕ Add New
              </button>
              <button onClick={saveJSONedu}>💾 Save</button>
            </div>
          </div>







          <p className="mt-5" style={{ fontWeight: "500", marginTop: 20 }}>Education Payment <span style={{ color: 'red', fontWeight: '700' }}>
            {finedata?.edugateway === 1 ? "Phonepe" : finedata?.edugateway === 2 ? "Payu Alpha (old)" :  
            finedata?.edugateway === 8 ? "Bill desk" : finedata?.edugateway === 9 ? "Bill desk Edu" : "Payu Beta (new)"}</span></p>

          <p style={{ fontWeight: "500", marginTop: 18, marginBottom: 0 }}>1. Phonepe</p>
          <p style={{ fontWeight: "500", marginTop: 18, marginBottom: 0, marginTop: 0 }}>2. Payu Alpha (old)</p>
          <p style={{ fontWeight: "500", marginTop: 18, marginBottom: 0, marginTop: 0 }}>3. Payu Beta (new)</p>


          <div className="row mt-3" >
            <div className="col-6" >
              <select onChange={(e) => {
                setEduval(e.target.value)
              }} id="fruits" name="fruits" style={{ width: '50%' }}>
                <option value="1">Phonepe</option>
                <option value="2">Payu Alpha (old)</option>
                <option value="3">Payu Beta (new)</option>
                <option value="8">Billdesk</option>
                <option value="9">Billdesk Edu</option>
              </select>
            </div>
            <div className="col-6">
              <button
                onClick={() => {
                  Submitt('edu')
                }}
              >
                Submit
              </button>
            </div>
          </div>


          <p style={{ fontWeight: "500", marginTop: 20 }}>Utility Payment <span style={{ color: 'red', fontWeight: '700' }}>

            {finedata?.ultigateway === 1 ? "Phonepe" : finedata?.ultigateway === 2 ? "Payu Alpha (old)" : 
            finedata?.ultigateway === 8 ? "Bill desk" : finedata?.ultigateway === 9 ? "Bill desk Edu" : "Payu Beta (new)"} </span></p>

          <p style={{ fontWeight: "500", marginTop: 18, marginBottom: 0 }}>1. Phonepe</p>
          <p style={{ fontWeight: "500", marginTop: 18, marginBottom: 0, marginTop: 0 }}>2. Payu Alpha (old)</p>
          <p style={{ fontWeight: "500", marginTop: 18, marginBottom: 0, marginTop: 0 }}>3. Payu Beta (new)</p>


          <div className="row mt-3" >
            <div className="col-6" >
              <select onChange={(e) => {
                setUti(e.target.value)
                console.log(e.target.value, 'Payu Beta (new)')
              }} id="fruits" name="fruits" style={{ width: '50%' }}>
                <option value="1">Phonepe</option>
                <option value="2">Payu Alpha (old)</option>
                <option value="3">Payu Beta (new)</option>
                <option value="8">Billdesk</option>
                <option value="9">Billdesk Edu</option>
              </select>
            </div>
            <div className="col-6">
              <button
                onClick={() => {
                  Submitt('uti')
                }}
              >
                Submit
              </button>
            </div>
          </div>



          <p style={{ fontWeight: "500", marginTop: 30 , fontWeight : '700' }}>Payment Method percentage utility</p>

            <div style={{ padding: 20 }}>
            {formBlocksa.map((block, index) => (
              <div key={index} className="row" style={{ marginBottom: 10 }}>
                <div className="col-2">
                  <select
                    onChange={(e) =>
                      handleChangea(index, "name", e.target.value) 
                    }
                    value={block.name}
                    style={{ width: "98%" }}
                  >
                    <option value="visa">Visa</option>
                    <option value="master">Mastercard</option>
                    <option value="RuPay">Rupay</option>
                    <option value="AMEX">Amex</option>
                    <option value="Dynex">Diner</option>
                    <option value="Prepaid">Prepaid</option>
                  </select>
                </div>

                <div className="col-5">
                  <div className="row" >
                     <div className="col-6">
                      <Select
                        isMulti
                        options={priorityOptions}
                        placeholder="Select priority..."
                        value={priorityOptions.filter(opt =>
                          (block.pro || []).includes(opt.value)
                        )}
                        onChange={(selected) =>
                          handleChangea(index, "pro", selected.map(opt => opt.value))
                        }
                        styles={{
                          control: (base) => ({
                            ...base,
                            minHeight: "38px",
                            borderColor: "#ccc",
                          }),
                        }}
                      />
                    </div>
                    <div className="col-6">
                      <input
                        type="text"
                        onChange={(e) =>
                          handleChangea(index, "charge", e.target.value)
                        }
                        value={block.charge}
                        placeholder="priority '[ '' "
                        style={{ width: "98%" }}
                      />
                    </div> 
                  </div> 
                </div> 

                <div className="col-1">
                  <button onClick={() => removeBlocka(index)}>❌</button>
                </div>
              </div>
            ))}

            <div style={{ marginTop: 20 }}>
              <button onClick={addNewBlocka} style={{ marginRight: 10 }}>
                ➕ Add New
              </button>
              <button onClick={saveJSONa}>💾 Save</button>
            </div>
          </div>


          <p style={{ fontWeight: "500", marginTop: 30 , fontWeight : '700' }}>Payment Method percentage Educaton</p>

            <div style={{ padding: 20 }}>
            {formBlocksae.map((block, index) => (
              <div key={index} className="row" style={{ marginBottom: 10 }}>
                <div className="col-2">
                  <select
                    onChange={(e) =>
                      handleChangeae(index, "name", e.target.value) 
                    }
                    value={block.name}
                    style={{ width: "98%" }}
                  >
                    <option value="visa">Visa</option>
                    <option value="master">Mastercard</option>
                    <option value="RuPay">Rupay</option>
                    <option value="AMEX">Amex</option>
                    <option value="Dynex">Diner</option>
                    <option value="Prepaid">Prepaid</option>
                  </select>
                </div>

                <div className="col-5">
                  <div className="row" >
                     <div className="col-6">
                      <Select
                        isMulti
                        options={priorityOptions}
                        placeholder="Select priority..."
                        value={priorityOptions.filter(opt =>
                          (block.pro || []).includes(opt.value)
                        )}
                        onChange={(selected) =>
                          handleChangeae(index, "pro", selected.map(opt => opt.value))
                        }
                        styles={{
                          control: (base) => ({
                            ...base,
                            minHeight: "38px",
                            borderColor: "#ccc",
                          }),
                        }}
                      />
                    </div>
                    <div className="col-6">
                      <input
                        type="text"
                        onChange={(e) =>
                          handleChangeae(index, "charge", e.target.value)
                        }
                        value={block.charge}
                        placeholder="priority '[ '' "
                        style={{ width: "98%" }}
                      />
                    </div> 
                  </div> 
                </div> 

                <div className="col-1">
                  <button onClick={() => removeBlockae(index)}>❌</button>
                </div>
              </div>
            ))}

            <div style={{ marginTop: 20 }}>
              <button onClick={addNewBlockae} style={{ marginRight: 10 }}>
                ➕ Add New
              </button>
              <button onClick={saveJSONae}>💾 Save</button>
            </div>
          </div>



        </div>
      </div>
    </div>
  );
};

export default ReneditGateway;
